const SET_CURRENT_ACTION = "setCurrentAction";
const SET_ISSUB_TABS = "setIsSubTabs";

const setCurrentAction = (payload) => {
    return {
        type: SET_CURRENT_ACTION,
        payload
    }
}

const setIsSubTabs = (payload) => {
    return {
        type: SET_ISSUB_TABS,
        payload
    }
}

const initialValues = {
    action: null,
    IsSubTabs: 'Fiat'
}

const currentActionReducer = (state, action) => {
    if (!state) {
        state = {
            ...initialValues,
            ...state
        }
    }
    switch (action.type) {
        case SET_CURRENT_ACTION:
            state = { ...state, action: action.payload };
            return state;
        case "removeCurrentAction":
            state = { ...state, action: null };
            return state;
        case SET_ISSUB_TABS:
            state = { ...state, IsSubTabs: action.payload };
            return state;
        default:
            return state;
    }
}
export default currentActionReducer;
export { setCurrentAction, setIsSubTabs }